import React from "react"
import styled from "styled-components"
import Image from "next/image"
import { useTranslation } from "next-i18next"
import { themeGet } from "@styled-system/theme-get"

const Fade = require("react-reveal/Fade")

interface IconCardProps {
  url?: string
  img: string
  alt: string
  tagD?: string
  showTag?: boolean
}

export default function IconCard({
  url,
  img,
  alt,
  tagD,
  showTag
}: IconCardProps) {
  const { t } = useTranslation("common")
  return (
    <Wrapper className={showTag ? "partnerBox borderBox" : "partnerBox"}>
      <a href={url} target={"blank"}>
        <Fade bottom>
          <PartnerImgWrapper>
            <Image
              src={img}
              alt={alt}
              fill
              sizes="100vw"
              style={{
                objectFit: "contain"
              }}
            />
          </PartnerImgWrapper>
        </Fade>
        {showTag && tagD && (
          <div className="tagD">
            <p>{t(tagD)}</p>
          </div>
        )}
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 calc(100% / 5);
  height: 150px;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease-in-out;
  position: relative;
  border-radius: calc(30px / 3);
  max-width: 60%;

  a {
    width: 100%;
    max-width: 300px;
    padding: 0 10%;
  }

  &.borderBox {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      border: 1px solid rgba(255, 255, 255, 0.33);
      border-radius: 12px;
      transform: translate(-50%, -50%);
    }
  }

  &:nth-child(n + 5) {
    flex: 1 1 calc(100% / 5);
    max-width: calc(100% / 5);
  }

  .tagD {
    background-color: ${themeGet("colors.secondary")};
    position: absolute;
    bottom: 0px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(30px / 6);
    transition: 0.1s ease-in;

    @media (max-width: 600px) {
      bottom: -12px;
      right: -12px;
    }

    p {
      color: rgb(255, 255, 255);
      margin-top: 0px !important;
      padding: 4px 12px;
      font-size: 14px;
      font-weight: 600;
    }
  }

  &:hover {
    // border: 1px solid $colorslightBlue;
    transform: scale(1.05);

    .partnerImg {
      filter: drop-shadow(1px 3px 5px $colorslightBlue);
    }

    .tagD {
      opacity: 1 !important;
    }
  }

  @media (max-width: 1300px) {
    flex: 1 1 calc(100% / 4);
    height: 150px;
    max-width: 50%;

    &:nth-child(n + 5) {
      flex: 1 1 calc(100% / 4);
      max-width: calc(100% / 4);
    }
  }

  @media (max-width: 600px) {
    max-width: 450px !important;
    flex: 1 1 calc(100% / 2);
    height: 120px;
    max-width: 90%;

    &:nth-child(n + 5) {
      flex: 1 1 calc(100% / 2);
      max-width: 50% !important;
    }
  }
`

const PartnerImgWrapper = styled.div`
  position: relative;
  width: 100%;
  transition: 1s;
  padding-top: 50%;
`
